angular.module('gym.payers').controller('LinkPayerModalCtrl', ["$scope", "$rootScope", "$window", "$http", "$modalInstance", "flash", "payer", "type", function($scope, $rootScope, $window, $http, $modalInstance, flash, payer, type) {
  var gym;
  gym = $rootScope.gym;
  $scope.onSelect = function(contact) {
    var message, payerDetails, url;
    payerDetails = type === 'ezidebit_payers' ? `${payer.first_name} ${payer.last_name} (${payer.your_system_reference})` : `${payer.stripe_customer_reference}`;
    message = `This will link the payer ${payerDetails} to ${contact.first_name} ${contact.last_name} (${contact.email}). Are you sure?`;
    if ($window.confirm(message)) {
      url = `/gyms/${gym.id}/${type}/${payer.id}?contact_id=${contact.id}`;
      return $http.put(url).then(function() {
        return $modalInstance.close();
      }, function(response) {
        flash.error = response.data.error || "Request could not be completed. Please try again";
        return $modalInstance.close();
      });
    }
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
